import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { BreadcrumbItem } from '@/components/ui/Breadcrumb';

interface NavItem {
  path: string;
  label: string;
}

const navItems: NavItem[] = [
  { path: '/', label: 'Dashboard' },
  { path: '/users', label: 'Users' },
  { path: '/organizations', label: 'Organizations' },
  { path: '/analytics', label: 'Analytics' },
  { path: '/audit-logs', label: 'Audit Logs' },
];

export const useBreadcrumbs = (): BreadcrumbItem[] => {
  const location = useLocation();

  return useMemo(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [{ label: 'Dashboard', path: '/' }];

    if (location.pathname === '/') {
      return breadcrumbs;
    }

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;

      const navItem = navItems.find((item) => item.path === currentPath);

      if (navItem) {
        breadcrumbs.push({ label: navItem.label, path: currentPath });
      } else {
        // Handle dynamic routes like /users/:id or /organizations/:id
        const parentPath = `/${pathSegments.slice(0, index).join('/')}`;
        const parentItem = navItems.find((item) => item.path === parentPath);

        if (parentItem && index === pathSegments.length - 1) {
          // This is likely a detail page - use the segment as the label
          const label = segment.charAt(0).toUpperCase() + segment.slice(1);
          breadcrumbs.push({ label, path: currentPath });
        }
      }
    });

    return breadcrumbs;
  }, [location.pathname]);
};
